angular.module("vgresiduos").controller("DocumentTypeEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/fornecedores/tipo-documento/${$stateParams.id}`);
		};
	}
]);
